/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
// material
import { Switch } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './configtoggle_styles';


/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - SECTION GROUP ~~~~~~~~~~ ========== */
const ConfigToggle = (props) => {
    const {
        checked,
        onChange,
        title,
        description,
        children
    } = props

    const [isChecked, setIsChecked] = useState(checked)

    useEffect(() => {
      setIsChecked(checked)
    }, [checked])
    
    return (
      <div className={`configtoggle ${props.classes.configtoggle}`}>
        <div className={'header'}>
          <div className={'toggle'}>
            <Switch on={!!isChecked} handleClick={()=>{
              setIsChecked(!isChecked)
              if(onChange) onChange(!isChecked)
            }} variant={'primary'} />
            <h3 className='title'>{title}</h3>
          </div>
          {description && <p className='description'>{description}</p>}
        </div>
        {children && <div className={`content checked-${!!isChecked}`}>{children}</div>}
      </div>
    )
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ConfigToggle);
